<template>
  <v-container fluid fill-height class="px-0">
    <template>
      <div class="text-center">
        <v-dialog v-model="dialogT" width="80%" persistent>
          <v-card>
            <v-card-text class="px-0 py-0">
              <vue-pdf-app style="height: 80vh" :pdf="urlPreview"></vue-pdf-app>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="warning"
                @click="closeResultDialog"
                :loading="isLoadingDelete"
                :disabled="creatingNewReport"
              >
                Cerrar
              </v-btn>
              <!-- <v-btn
                v-if="showGenerate"
                text
                color="success"
                :disabled="isLoadingDelete"
                :loading="creatingNewReport"
                @click="generateNewReport()"
              >
                Generar reporte final
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <v-row align="center" class="mt-n2 mb-2" dense>
      <v-col cols="12" sm="6" md="7">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          label="Buscar por folio, cliente, ID proyecto..."
          clearable
          type="text"
          dense
          outlined
          hide-details
          class="white rounded-lg"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="5" class="text-end d-flex justify-end align-center">
        <v-dialog
          v-model="filterDialog"
          width="500"
          :fullscreen="$vuetify.breakpoint.xsOnly"
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on" rounded small elevation="0" class="mr-2">
              <v-icon left size="18">mdi-filter-multiple</v-icon> Filtros
            </v-btn>
          </template>
          <!-- ... card content remains same ... -->

          <v-card
            class="rounded-lg flex d-flex flex-column"
            :height="$vuetify.breakpoint.xsOnly ? '100%' : '600'"
            min-height="300"
          >
            <v-card-title class="headline primary white--text">
              Filtros
              <v-spacer></v-spacer>
              <v-btn icon dark @click="filterDialog = false" v-if="$vuetify.breakpoint.xsOnly">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="overflow-y-auto">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span> Tipo de análisis </span>
                    <v-autocomplete
                      v-model="form.analysisType"
                      :items="analysisType"
                      label="Seleccione tipo de análisis"
                      no-data-text="No hay tipo de análisis"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="form.type"
                      :items="types"
                      label="Seleccione tipo de laboratorio"
                      no-data-text="No hay tipos laboratorio"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Tipo de cliente </span>
                    <v-autocomplete
                      v-model="form.clientType"
                      :items="clientTypes"
                      label="Seleccione tipo de cliente"
                      no-data-text="No hay tipo de cliente"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Estatus </span>
                    <v-autocomplete
                      v-model="form.status"
                      :items="status"
                      label="Seleccione tipo de análisis"
                      no-data-text="No hay cultivo"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <span> Reporte generado </span>
                    <v-autocomplete
                      v-model="form.report"
                      :items="reports"
                      label="Seleccione tipo de análisis"
                      no-data-text="No hay cultivo"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Tipò de muestra </span>
                    <v-autocomplete
                      v-model="form.sampleType"
                      :items="sampleType"
                      label="Seleccione tipo de muestra"
                      solo
                      no-data-text="No hay cultivo"
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Cultivo </span>
                    <v-autocomplete
                      v-model="form.cropCycle"
                      :items="crop_items"
                      label="Seleccione un cultivo"
                      no-data-text="No hay cultivo"
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Errores de registro </span>
                    <v-autocomplete
                      v-model="form.error"
                      :items="errors"
                      label="Seleccione tipo de error"
                      hide-no-data
                      solo
                      dense
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-container>
                <v-row>
                  <v-col>
                    <v-btn
                      color="gray"
                      dark
                      @click="filterDialog = false"
                      block
                    >
                      Cancelar
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn color="info" @click="cleanFilters" block>
                      Limpiar filtros
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn color="primary" @click="applyFilters" block>
                      Aplicar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" rounded small class="mr-2" @click="fetchData" elevation="0" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon :left="!$vuetify.breakpoint.xsOnly"> mdi-refresh </v-icon> 
          <span v-if="!$vuetify.breakpoint.xsOnly">Refrescar</span>
        </v-btn>
        <v-tooltip
          bottom
          v-if="
            authenticatedUser &&
            authenticatedUser.permission &&
            authenticatedUser.permission.exportReception
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="grey darken-1"
              dark
              rounded
              small
              elevation="0"
              :loading="isExporting"
              @click="download"
            >
              <v-icon> mdi-file-export </v-icon>
            </v-btn>
          </template>
          <span>Exportar a CSV</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="mt-n4">
      <v-col>
        <!-- @click:row="(item) => handleClick(item)" -->
        <v-data-table
          width="100%"
          :height="$vuetify.breakpoint.smAndDown ? 'auto' : `calc(100vh - 350px)`"
          fixed-header
          :headers="headers"
          :items="analysis"
          :single-expand="true"
          :expanded.sync="expanded"
          show-expand
          v-model="selectedParend"
          :items-per-page="10"
          no-data-text="No hay recepciones"
          loading-text="Cargando recepciones..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
          item-key="_id"
        >
          <template #[`item.folio`]="{ item }">
            <span
              class="text-caption"
              v-if="!item.project_kit && !item.setup_kit"
              >{{ item.folio }}</span
            >
            <v-tooltip bottom v-else-if="item.project_kit">
              <template v-slot:activator="{ on, attrs }">
                <v-chip small color="secondary" v-bind="attrs" v-on="on">
                  {{ item.folio }}
                </v-chip>
              </template>
              <span>Kit de proyecto</span>
            </v-tooltip>
            <v-tooltip bottom v-else-if="item.setup_kit">
              <template v-slot:activator="{ on, attrs }">
                <v-chip small color="warning" v-bind="attrs" v-on="on">
                  {{ item.folio }}
                </v-chip>
              </template>
              <span>Kit de setup</span>
            </v-tooltip>
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip color="#dadada">
              {{ getStatus(item.status) }}
            </v-chip>
            <v-tooltip bottom v-if="item.statusReception === 'ERROR'">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="red" v-bind="attrs" v-on="on"
                  >mdi-alert-circle</v-icon
                >
              </template>
              <span>Contenedores sin muestras</span>
            </v-tooltip>

            <v-tooltip bottom v-else-if="item.statusReception === 'PENDING'">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="info" v-bind="attrs" v-on="on"
                  >mdi-alert-circle</v-icon
                >
              </template>
              <span>Contenedores pendientes</span>
            </v-tooltip>
            <v-tooltip bottom v-else-if="item.statusReception === 'SEND'">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" v-bind="attrs" v-on="on"
                  >mdi-alert-circle</v-icon
                >
              </template>
              <span>Muestra enviada a laboratorio</span>
            </v-tooltip>
          </template>
          <template #[`item.analysis_monitoring`]="{ item }">
            {{ getAnalysisType(item.analysis_monitoring) }}
            {{ getType(item.analysis_type) }}
          </template>
          <template #[`item.date_reception`]="{ item }">
            {{ dateFormat(item.date_reception) }}
            <v-icon @click="showDialogTimeLine(item._id)" color="primary"
              >mdi-timeline-clock</v-icon
            >
          </template>
          <template #[`item.lastResultDate`]="{ item }">
            <div v-if="item.lastResultDate">
              {{ dateFormat(item.lastResultDate) }}
            </div>
            <div v-else>No generado</div>
          </template>
          <template #[`item.results`]="{ item }">
            <template v-if="item.results.length > 0">
              <v-tooltip bottom v-if="item.results.includes('Measure')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    @click.stop="showReport(item.results)"
                    >mdi-file-document
                  </v-icon>
                </template>
                <span>Reporte de medición</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.results.includes('Valuation')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    @click.stop="showReport(item.results)"
                    >mdi-file-document
                  </v-icon>
                </template>
                <span>Reporte de valuación</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.results.includes('qPCR')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="blue"
                    @click.stop="showReport(item.results)"
                    >mdi-file-document
                  </v-icon>
                </template>
                <span>Reporte de qPCR</span>
              </v-tooltip>
              <v-tooltip bottom v-else-if="item.results.includes('Prescription')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="blue"
                    @click.stop="showReport(item.results)"
                    >mdi-file-document
                  </v-icon>
                </template>
                <span>Reporte de qPCR</span>
              </v-tooltip>
            </template>
            <template v-else>
              <v-icon color="grey lighten-3">mdi-file-document</v-icon>
            </template>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-div v-if="item.actions"></v-div>
            <v-row no-gutters>
              <v-col cols="6" xl="3" lg="3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      :loading="item.isLoading"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      @click="showReportGenerate(item)"
                    >
                      <v-icon color="primary" class="mx-2"
                        >mdi-file-chart</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Resultados</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
          <template #[`item.kit_type`]="{ item }">
            <template v-if="item.kit_package">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    :color="item.match_kit_package ? 'primary' : 'warning'"
                    small
                    v-bind="attrs"
                    v-on="on"
                    v-if="item.kit_type"
                    class="package__type"
                    @click="showChangePackageDialog(item)"
                    >{{ getKitType(item.kit_type) }}
                  </v-chip>
                  <v-chip
                    :color="item.match_kit_package ? 'primary' : 'warning'"
                    v-bind="attrs"
                    v-on="on"
                    small
                    class="package__type"
                    @click="showChangePackageDialog(item)"
                    v-else
                    >N.E.</v-chip
                  >
                </template>
                <span>Paquete CMDA: {{ item.kit_package }}</span>
              </v-tooltip>
            </template>
            <template v-else>
              <span class="text-caption" v-if="item.kit_type" @click="showChangePackageDialog(item)">{{
                getKitType(item.kit_type)
              }}</span>
              <span class="text-caption" v-else @click="showChangePackageDialog(item)">N.E.</span>
            </template>
          </template>
          <template #[`item.client_type`]="{ item }">
            <span v-if="item.client_type">{{ item.client_type }}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.zone`]="{ item }">
            <span v-if="item.zone">{{ item.zone }}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.labs`]="{ item }">
            <v-icon @click="openLabsModal(item)"> mdi-routes</v-icon>
          </template>
          <template #[`item.result_date`]="{ item }">
            <div v-if="item.result_date">
              <span class="text-caption">{{ item.result_date }}</span>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    @click="showDateResultHistoryModal(item)"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-clipboard-text-clock-outline</v-icon
                  >
                </template>
                <span>Historial fechas</span>
              </v-tooltip>
            </div>
            <div v-else>
              <span class="text-caption">--/--/--</span>
            </div>

            <!-- <v-icon @click="openDatesResultsModal(item)">
              mdi-clipboard-text-clock
            </v-icon> -->
          </template>
          <template #[`item.guide`]="{ item }">
            <v-icon @click="openGuideModel(item)"> mdi-map-marker-path </v-icon>
          </template>
          <template #expanded-item="{ headers, item }">
            <td class="px-0 py-2" :colspan="headers.length">
              <template>
                <v-data-table
                  v-model="selectedChild"
                  :headers="headersChild"
                  :items="item.receptions"
                  item-key="qr_container"
                  hide-default-footer
                  elevation="0"
                  :items-per-page="100"
                >
                  <template #[`item.folio_sample`]="{ item }">
                    <span class="primary--text">{{ item.folio_sample }}</span>
                  </template>
                  <template #[`item.metagenomicId`]="{ item }">
                    <span>{{ item.metagenomicId || "N/A" }}</span>
                  </template>
                  <template #[`item.projectStatus`]="{ item }">
                    <v-chip
                      small
                      :color="
                        item.projectStatus === 'DIAGNOSIS'
                          ? 'info'
                          : item.projectStatus === 'NEW'
                          ? 'success'
                          : item.projectStatus === 'PENDING'
                          ? 'warning'
                          : '#dadada'
                      "
                      dark
                    >
                      {{ getProjectStatus(item.projectStatus) }}
                    </v-chip>
                  </template>
                  <template #[`item.assignedTo`]="{ item }">
                    <span>{{ item.assignedTo || "N/A" }}</span>
                  </template>
                  <template #[`item.sample_type`]="{ item }">
                    {{ getAnalysisType(item.tracingStatus) }}
                    {{ getSampleType(item.sample_type) }}
                  </template>
                  <template #[`item.crop`]="{ item }">
                    {{ getCrop(item.crop) }}
                  </template>
                  <template #[`item.date_field_registration`]="{ item }">
                    {{ dateFormat(item.date_field_registration) }}
                  </template>
                  <template #[`item.last_update`]="{ item }">
                    {{ lastUpdate(item.last_update) }}
                  </template>
                  <template #[`item.analysis_stage`]="{ item }">
                    <v-chip color="#dadada">
                      {{ getStatus(item.analysis_stage) }}
                    </v-chip>
                  </template>
                  <template #[`item.irrigation_unit_name`]="{ item }">
                    <span
                      v-if="item.farm_unit_id"
                      class="primary--text"
                      @click="goToDetailTracing(item.farm_unit_id)"
                    >
                      {{ item.irrigation_unit_name }}
                    </span>
                    <span v-else>
                      {{ item.irrigation_unit_name }}
                    </span>
                  </template>
                </v-data-table>
              </template>
            </td>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
          class="mt-n2"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-row class="text-center" v-if="showFetchingDataButton">
      <v-col>
        <v-btn color="primary" rounded @click="fetchData"
          ><v-icon>mdi-refresh</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <TimeLineReception v-model="showTimeLine" :analysis="timeLineAnalysis" />
    <LabsModal v-model="showLabsModal" :analysis="anaalysisLabs" />
    <DatesResultsModal v-model="showDatesResultsModal" />
    <GuideModal v-model="showGuideModal" v-if="showGuideModal" />
    <TimeLineResultsDate
      v-model="showTimeLineResultsDate"
      v-if="showTimeLineResultsDate"
    />
    <SetPackageInAnalysisModal
      @hide="hideChangePackageDialog"
      v-if="showSetPackageInAnalysisModal"
      v-model="showSetPackageInAnalysisModal"
    />
  </v-container>
</template>
<script>
//Vuex
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
//Libraries
import dayjs from "dayjs";
//pdf viewer
import VuePdfApp from "vue-pdf-app";
import TimeLineReception from "@/components/reception/modals/TimeLineReception.vue";
import LabsModal from "@/components/reception/modals/LabsModal.vue";
import DatesResultsModal from "@/components/reception/modals/DatesResultsModal.vue";
import GuideModal from "@/components/reception/modals/GuideModal";
import TimeLineResultsDate from "@/components/reception/modals/TimeLineResultsDate.vue";
import SetPackageInAnalysisModal from "@/components/reception/modals/SetPackageInAnalysisModal.vue";
//axios
import axios from "axios";

export default {
  components: {
    VuePdfApp,
    TimeLineReception,
    LabsModal,
    DatesResultsModal,
    GuideModal,
    TimeLineResultsDate,
    SetPackageInAnalysisModal,
  },
  data: () => ({
    showTimeLineResultsDate: false,
    anaalysisLabs: null,
    timeLineAnalysis: null,
    types: ["SOLENA", "CMDA"],
    urlPreview: "",
    dialogT: false,
    expanded: [],
    analysis: [],
    fetchingData: false,
    showGenerate: false,
    selectedChild: [],
    selectedParend: [],
    creatingNewReport: false,
    page: 1,
    currentFolioToGenerate: null,
    heyReport: null,
    isLoadingDelete: false,
    numPages: 0,
    search: "",
    showFetchingDataButton: false,
    filterDialog: false,
    crop_items: [],
    status: [
      {
        text: "Recibida",
        value: "RECEIVED",
      },
      {
        text: "Midiendo",
        value: "MEASURING",
      },
      {
        text: "Medido",
        value: "MEASURED",
      },
      {
        text: "Valuando",
        value: "VALUATING",
      },
      {
        text: "Valuado",
        value: "VALUATED",
      },
    ],
    sampleType: [
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
      {
        text: "Vegetal",
        value: "MAS_VEGETABLE",
      },
      {
        text: "Vegetal sin georeferencia",
        value: "VEGETABLE",
      },
      {
        text: "Composta",
        value: "COMPOST",
      },
      {
        text: "Producto",
        value: "PRODUCT",
      },
      {
        text: "Sustrato",
        value: "SUBSTRATUM",
      },
      {
        text: "Suelo sin asesor",
        value: "NO_ADVISOR",
      },
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
    ],
    analysisType: [
      {
        text: "Inicial",
        value: "INITIAL",
      },
      {
        text: "Seguimiento",
        value: "MONITORING",
      },
    ],
    reports: [
      {
        text: "Medición",
        value: "measuring",
      },
      {
        text: "Valuación",
        value: "valuation",
      },
    ],
    errors: [
      {
        text: "Sin errores",
        value: "SUCCESS",
      },
      {
        text: "Con errores",
        value: "ERROR",
      },
      {
        text: "Pendiente",
        value: "PENDING",
      },
    ],
    clientTypes: [
      {
        text: "PROAGRO",
        value: "PROAGRO",
      },
      {
        text: "SOLENA",
        value: "SOLENA",
      },
      {
        text: "PUMA",
        value: "PUMA",
      },
    ],
    form: {
      cropCycle: null,
      sampleType: null,
      analysisType: null,
      type: null,
      status: null,
      report: null,
      error: null,
      clientType: null,
    },
    user: JSON.parse(localStorage.getItem("user")),
    showTimeLine: false,
    showLabsModal: false,
    showDatesResultsModal: false,
    showGuideModal: false,
    isExporting: false,
    showSetPackageInAnalysisModal: false,
  }),
  computed: {
    ...mapState("reception", [
      "crops",
      "refreshReceptionTable",
      "filters",
      "searchFilter",
      "cleanParent",
    ]),
    ...mapState(["cancelToken"]),
    ...mapState("session", ["authenticatedUser"]),
    headers() {
      const isMobile = this.$vuetify.breakpoint.xsOnly;
      const isSmallTablet = this.$vuetify.breakpoint.smOnly;

      const allHeaders = [
        { text: "Folio", value: "folio", sortable: false },
        { text: "Estatus", value: "status", sortable: false },
        { text: "Tipo de análisis", value: "analysis_monitoring", sortable: false },
        { text: "Tipo de kit", value: "kit_type", sortable: false },
        { text: "Tipo de cliente", value: "client_type", sortable: false },
        { text: "Zona", value: "zone", sortable: false },
        { text: "Laboratorio", value: "labs", align: "center", sortable: false },
        { text: "Guía", value: "guide", align: "center", sortable: false },
        { text: "Cliente", value: "client_name", sortable: false },
        { text: "Muestras", value: "qty_samples", sortable: false },
        { text: "Recepción", value: "date_reception", sortable: false },
        { text: "Fechas resultado", value: "result_date", align: "center", sortable: false },
        { text: "Resultados", value: "results", align: "center", sortable: false },
        { text: "Ultimo reporte enviado", value: "lastResultDate", sortable: false },
        // { text: "Acciones", value: "actions", align: "center", sortable: false },
      ];

      if (isMobile) {
        return allHeaders.filter(h => ["folio", "status", "client_name"].includes(h.value));
      }
      if (isSmallTablet) {
        return allHeaders.filter(h => ["folio", "status", "client_name", "date_reception"].includes(h.value));
      }
      return allHeaders;
    },
    headersChild() {
      const isMobile = this.$vuetify.breakpoint.xsOnly;
      const allHeaders = [
        { text: "Folio muestra", value: "folio_sample", align: "center", sortable: false },
        { text: "QR contenedor", value: "qr_container", sortable: false },
        { text: "ID proyecto", value: "metagenomicId", sortable: false },
        { text: "Estatus muestra en proyecto", value: "projectStatus", sortable: false },
        { text: "Responsable Comercial", value: "assignedTo", sortable: false },
        { text: "Tipo de muestra", value: "sample_type", sortable: false },
        { text: "# Submuestras", value: "sub_samples", sortable: false },
        { text: "Nombre de la unidad de riego", value: "irrigation_unit_name", sortable: false },
        { text: "Cultivo", value: "crop", sortable: false },
        { text: "Responsable", value: "sampler_name", sortable: false },
        { text: "Registro en campo", value: "date_field_registration", sortable: false },
        { text: "Última modificacción", value: "last_update", sortable: false },
        { text: "Etapa de análisis", value: "analysis_stage", sortable: false },
      ];

      if (isMobile) {
        return allHeaders.filter(h => ["folio_sample", "qr_container", "projectStatus", "crop"].includes(h.value));
      }
      return allHeaders;
    }
  },
  async mounted() {
    // window.addEventListener("resize", this.myEventHandler);
    this.page = parseInt(this.$route.params.page, 10);
    this.setCropItems();
    if (this.filters) {
      this.form = this.filters;
    }
    if (this.searchFilter && this.searchFilter.length > 0) {
      this.search = this.searchFilter;
    }
    await this.fetchData();
  },
  destroyed() {
    // window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    ...mapActions("reception", [
      "getAnalysisAdmin",
      "getFolioAnalysis",
      "generateResultData",
      "deleteTempFiles",
      "generateResults",
      "getDataToExport",
      "generateDiagnosis",
      "generateMonitoring",
      "getGuideInformation",
    ]),
    ...mapMutations("reception", [
      "SET_REFRESH_TABLE",
      "SHOW_UPDATE_FOLIO_DIALOG",
      "SET_FOLIO_SELECTED",
      "SET_SELECTED_RECEPTION",
      "SET_FILTERS",
      "SET_SEARCH",
      "SET_FOLIOS_SELECTED",
      "CLEAN_PARENT",
      "SET_GUIDE",
      "CAN_UPDATE_GUIDE",
    ]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async fetchData() {
      this.fetchingData = true;
      this.SET_FILTERS(this.form);
      this.SET_SEARCH(this.search);
      try {
        if (typeof this.cancelToken != "undefined") {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }
        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());
        let payload = {
          page: this.page,
          search: this.search,
          // laboratory: this.user.laboratory._id,
          filters: this.form,
        };
        let response = await this.getAnalysisAdmin(payload);

        if (response) {
          if (!response.error) {
            //hide loaders
            this.fetchingData = false;
            this.showFetchingDataButton = false;
            //set sample data
            console.log(response.analysis);
            this.analysis = response.analysis;
            this.numPages = response.pages;
          } else {
            throw response;
          }
        }
      } catch (e) {
        this.fetchingData = false;
        if (axios.isCancel(e)) {
          console.log("Request canceled", e.message);
          return;
        }
        //print log
        console.log(e);
        //hide loaders
        this.fetchingData = false;
        //show attempt button to try fetch data manually
        this.showFetchingDataButton = true;
        //show error to user
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar muestras en transito, intente de nuevo !!",
          timeout: 5000,
        });
      }
    },
    async cleanFilters() {
      this.search = null;
      this.filterDialog = false;
      this.form = {
        cropCycle: null,
        sampleType: null,
        analysisType: null,
        status: null,
        report: null,
        error: null,
        clientType: null,
        type: null,
      };
      await this.fetchData();
    },
    async applyFilters() {
      this.filterDialog = false;
      this.page = 1;
      await this.fetchData();
    },
    setCropItems() {
      let cropsArray = Object.entries(this.crops);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },
    getStatus(value) {
      const status = {
        RECEIVED: "Recibida",
        MEASURING: "Midiendo",
        MEASURED: "Medido",
        VALUATING: "Valuando",
        VALUATED: "Valuado",
      };
      let newValue = status[value];
      return newValue ? newValue : "Esperando...";
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "--";
      } else {
        return "--";
      }
    },
    getCrop(value) {
      let template = "";
      const crop = {
        olive: "Aceituna",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Aguacate",
        garlic: "Ajo",
        sesame: "Ajonjolí",
        basil: "Albahaca",
        artichoke: "Alcachofa",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfalfa achicalada",
        greenAlfalfa: "Alfalfa verde",
        cotton: "Algodón",
        almond: "Almendro",
        birdseed: "Alpiste",
        amaranth: "Amaranto",
        anise: "Anís",
        celery: "Apio",
        blueberry: "Arándano",
        myrtle: "Arrayán",
        rice: "Arroz",
        greenForageOats: "Avena forrajera en verde",
        oatGrain: "Avena grano",
        bamboo: "Bambú",
        eggplant: "Berenjena",
        beetroot: "Betabel",
        broccoli: "Brocoli",
        peanut: "Cacahuate",
        cocoa: "Cacao",
        cherryCoffee: "Café cereza",
        pumpkin: "Calabaza",
        sweetPotato: "Camote",
        sugarCane: "Caña de azúcar",
        canola: "Canola",
        carambolo: "Carambolo",
        safflower: "Cártamo",
        barley: "Cebada",
        greenForageBarley: "Cebada forrajera en verde",
        onion: "Cebolla",
        chives: "Cebollín",
        ryeGrain: "Centeno grano",
        cherry: "Cereza",
        chabacano: "Chabacano",
        pea: "Chícharo",
        squash: "Chayote",
        chia: "Chía",
        chilacayote: "Chilacayote",
        chillyPepper: "Chile / Pimiento",
        custardApple: "Chirimoya",
        coriander: "Cilantro",
        plum: "Ciruela",
        coconutFruit: "Coco fruta",
        cabbage: "Col (repollo)",
        brusselsSprouts: "Col de Bruselas",
        cauliflower: "Coliflor",
        cumin: "Comino",
        chrysanthemum: "Crisantemo (planta)",
        peach: "Durazno",
        date: "Dátil",
        greenBean: "Ejote",
        cornCob: "Elote",
        dill: "Eneldo",
        epazote: "Epazote",
        asparagus: "Espárrago",
        spicesAndMedicinals: "Especias y medicinales",
        spinach: "Espinaca",
        raspberry: "Frambuesa",
        strawberry: "Fresa",
        bean: "Frijol",
        chickpea: "Garbanzo",
        sunflower: "Girasol",
        pomegranate: "Granada",
        soursop: "Guanábana",
        guava: "Guayaba",
        henequen: "Henequén",
        peppermint: "Hierbabuena",
        aromaticHerbs: "Hierbas aromáticas",
        fig: "Higo",
        jamaica: "Jamaica",
        ginger: "Jenjibre",
        jicama: "Jícama",
        lettuce: "Lechuga",
        lentil: "Lenteja",
        lime: "Lima",
        lemon: "Limón",
        linseed: "Linaza",
        litchi: "Litchi",
        corn: "Maíz",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Mandarina",
        mango: "Mango",
        mangosteen: "Mangostán",
        chamomile: "Manzanilla",
        appleTree: "Manzano",
        passionFruit: "Maracuyá",
        daisyFlower: "Margarita",
        marjoram: "Mejorana",
        melon: "Melón",
        quince: "Membrillo",
        mint: "Menta",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Naranja",
        medlar: "Níspero",
        nochebuena: "Nochebuena (planta)",
        walnut: "Nogal",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamentales",
        orchid: "Orquídea (planta)",
        oilPalm: "Palma africana o de aceite",
        potato: "Papa",
        papaya: "Papaya",
        grasslands: "Pastizales",
        matGrass: "Pasto tapete (m2)",
        pasturesAndMeadows: "Pastos y praderas",
        cucumber: "Pepino",
        pearTree: "Peral",
        parsley: "Perejil",
        peron: "Perón",
        persimony: "Persimonio",
        pepper: "Pimienta",
        pineapple: "Piña",
        pinion: "Piñón",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Plátano",
        pore: "Poro",
        radish: "Rábano",
        rambutan: "Rambután",
        romerito: "Romerito",
        rosemary: "Romero",
        aloe: "Sábila",
        watermelon: "Sandía",
        sorghum: "Sorgo",
        soy: "Soya",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate Rojo (jitomate)",
        greenTomato: "Tomate Verde",
        thyme: "Tomillo",
        grapefruit: "Toronja (pomelo)",
        clover: "Trébol",
        wheat: "Trigo",
        dutchTulip: "Tulipán holandés",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Vainilla",
        purslane: "Verdolaga",
        vine: "Vid",
        cassavaFood: "Yuca alimenticia",
        carrot: "Zanahoria",
        sapodilla: "Zapote",
        blackberry: "Zarzamora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Barbecho",
        other: "Otro",
      };
      let cropName = crop[value];
      if (cropName) {
        template = cropName;
      } else {
        template = "Sin cultivo";
      }
      return template;
    },
    getAnalysisType(value) {
      if (value == "INITIAL" || value == "Initial") {
        return "Inicial";
      } else {
        return "Seguimiento";
      }
    },
    getType(value) {
      let types = {
        CMDA: "CMDA",
        SOLENA: "Clásico",
      };
      let type = types[value];
      if (type) {
        return type;
      } else {
        return "";
      }
    },
    getProjectStatus(value) {
      let statuses = {
        DIAGNOSIS: "DIAGNOSTICADO",
        NEW: "NUEVO",
        PENDING: "PENDIENTE",
      };
      return statuses[value] || value || "N/A";
    },
    getSampleType(value) {
      const types = {
        CLASSIC: "Suelo compuesto",
        MAS: "Muestra para genómica",
        MAS_VEGETABLE: "Vegetal",
        VEGETABLE: "Vegetal sin georeferencia",
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        NO_ADVISOR: "Suelo sin asesor",
      };
      if (value.type) {
        let temp = types[value.type];
        if (value.type == "COMPOST" || value.type == "PRODUCT") {
          if (value.composition) {
            let compositions = {
              LIQUID: "Líquido",
              SOLID: "Sólido",
            };
            temp += ` ${compositions[value.composition]}`;
          }
        } else if (value.type == "MAS_VEGETABLE" || value.type == "VEGETABLE") {
          if (value.vegetableType) {
            let vegetableTypes = {
              Seedling: "Plántula",
              Root: "Raíz",
              Seed: "Semilla",
              Stem: "Tallo",
              Leaf: "Hoja",
              Fruit: "Fruto",
              Flower: "Flor",
            };
            if (vegetableTypes[value.vegetableType]) {
              temp += ` ${vegetableTypes[value.vegetableType]}`;
            }
          }
        }
        return temp;
      } else {
        return "--";
      }
    },
    downloadPDF(value) {
      if (value.length > 0) {
        var a = document.createElement("a");
        a.href = value;
        let fileName = value.split("/").pop();
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(value);
        a.remove();
      }
    },
    lastUpdate(date) {
      if (date) {
        let now = new Date();
        let update = new Date(date);
        const diffTime = Math.abs(update - now);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        var cd = 24 * 60 * 60 * 1000,
          ch = 60 * 60 * 1000,
          d = Math.floor(diffTime / cd),
          h = Math.floor((diffTime - d * cd) / ch),
          m = Math.round((diffTime - d * cd - h * ch) / 60000),
          pad = function (n) {
            return n < 10 ? "0" + n : n;
          };
        if (m === 60) {
          h++;
          m = 0;
        }
        if (h === 24) {
          d++;
          h = 0;
        }
        let template = "Hace ";
        let day = d;
        let houres = pad(h);
        let minutes = pad(m);
        let nothing = 0;
        if (day > 0) {
          if (day <= 1) {
            template += `${day} día `;
          } else {
            template += `${day} días `;
          }
        } else {
          nothing++;
        }

        if (houres > 0) {
          if (houres <= 1) {
            template += `${houres} hora `;
          } else {
            template += `${houres} horas `;
          }
        } else {
          nothing++;
        }

        if (minutes > 0) {
          if (minutes <= 1) {
            template += `${minutes} minuto`;
          } else {
            template += `${minutes} minutos`;
          }
        } else {
          nothing++;
        }

        if (nothing++ == 3) {
          template += `unos segundos`;
        }

        return template;
      } else {
        return "--";
      }
    },
    showReport(url) {
      this.urlPreview = url;
      this.dialogT = true;
      this.showGenerate = false;
    },
    async showReportGenerate(item) {
      try {
        if (item.analysis_monitoring === "INITIAL") {
          item.isLoading = true;
          const response = await this.generateDiagnosis({
            analysisId: item._id,
            laboratory: this.user.laboratory._id,
          });
          if (response) {
            if (!response.error) {
              this.currentFolioToGenerate = item._id;
              let url = response.result;
              this.heyReport = response.key;
              item.isLoading = false;
              this.urlPreview = url;
              this.dialogT = true;
              this.showGenerate = true;
            } else {
              item.isLoading = false;
              throw response;
            }
          } else {
            item.isLoading = false;
            throw response;
          }
        } else {
          item.isLoading = true;
          const response = await this.generateMonitoring({
            analysisId: item._id,
            // laboratory: this.user.laboratory._id,
          });
          if (response) {
            if (!response.error) {
              this.currentFolioToGenerate = item._id;
              let url = response.result;
              this.heyReport = response.key;
              item.isLoading = false;
              this.urlPreview = url;
              this.dialogT = true;
              this.showGenerate = true;
            } else {
              item.isLoading = false;
              throw response;
            }
          } else {
            item.isLoading = false;
            throw response;
          }
        }
      } catch (e) {
        item.isLoading = false;
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al generar resultado, intente de nuevo !!",
          timeout: 5000,
        });
      }
    },
    async updateFolio(_id) {
      try {
        // console.log(_id);
        let payload = {
          id: _id,
          laboratory: this.user.laboratory._id,
        };
        let response = await this.getFolioAnalysis(payload);
        if (response) {
          if (!response.error) {
            console.log(response.analysis);
            this.SET_FOLIO_SELECTED(response.analysis);
            this.SHOW_UPDATE_FOLIO_DIALOG(true);
          } else {
            throw response;
          }
        } else {
          throw response;
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al intentard editar folio, intente de nuevo !!",
          timeout: 5000,
        });
      }
    },
    handleClick(item) {
      this.SET_SELECTED_RECEPTION(item);
      this.$router.push(`/physicochemical-test/${item._id}`);
    },
    async generateNewReport() {
      try {
        this.creatingNewReport = true;
        let folios = [this.currentFolioToGenerate];
        let response = await this.generateResults({
          folios: folios,
          laboratory: this.user.laboratory._id,
        });
        if (response) {
          if (response.error) throw response;
          this.creatingNewReport = false;
          await this.closeResultDialog();
          await this.fetchData();
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Reporte generado exitosamente !!",
            timeout: 5000,
          });
        } else {
          throw response;
        }
      } catch (e) {
        this.creatingNewReport = false;
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al generar resultado final, intente de nuevo !!",
          timeout: 5000,
        });
      }
    },
    async closeResultDialog() {
      if (this.showGenerate) {
        this.isLoadingDelete = true;
        //delete temp file
        let keys = [this.heyReport];
        await this.deleteTempFiles(keys);
        this.isLoadingDelete = false;
        this.dialogT = false;
        this.urlPreview = "";
      } else {
        this.dialogT = false;
        this.urlPreview = "";
      }
    },
    goToDetail(_id) {
      this.$router.push(`/tracing-sample/${_id}`);
    },
    goToDetailTracing(_id) {
      this.$router.push(`/tracing/${_id}`);
    },
    showDialogTimeLine(value) {
      this.showTimeLine = true;
      this.timeLineAnalysis = value;
    },
    openLabsModal(labs) {
      this.anaalysisLabs = labs;
      this.showLabsModal = true;
    },
    openDatesResultsModal() {
      this.showDatesResultsModal = true;
    },
    async openGuideModel(item) {
      let codes = [];

      for (let reception of item.receptions) {
        codes.push(reception.qr_container);
      }

      let response = await this.getGuideInformation({ codes: codes });
      if (!response.error) {
        this.CAN_UPDATE_GUIDE(false);
        this.SET_GUIDE(response.shipment);
        this.showGuideModal = true;
      } else {
        this.CAN_UPDATE_GUIDE(false);
        this.SET_GUIDE(null);
        this.showGuideModal = true;
      }
    },
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";

      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";

          line += array[i][index];
        }

        str += line + "\r\n";
      }

      return str;
    },
    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }

      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = this.convertToCSV(jsonObject);

      var exportedFilenmae = fileTitle + ".csv" || "export.csv";

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    async download() {
      this.isExporting = true;
      let allData = [];
      let flag = true;
      let pages = 1;
      while (flag) {
        let payload = {
          page: pages,
          search: this.search,
          // laboratory: this.user.laboratory._id,
          filters: this.form,
        };

        let response = await this.getDataToExport(payload);

        if (response) {
          if (!response.error) {
            //set sample data
            for (let item of response.analysis) {
              item.client_name = item.client_name.replace(/,/g, "");
              item.billingInformation = item.billingInformation.replace(
                /,/g,
                ""
              );
              item.zone = item.zone.replace(/,/g, "");
              item.sampler_name = item.sampler_name.replace(/,/g, "");
              allData.push(item);
            }
          }
        }

        if (this.numPages > pages) {
          pages++;
        } else {
          flag = false;
        }
      }
      console.log(allData);
      var headers = {
        folio: "Folio".replace(/,/g, ""),
        status: "status".replace(/,/g, ""),
        analysis_type: "analysis type".replace(/,/g, ""),
        analysis_monitoring: "analysis monitoring".replace(/,/g, ""),
        client_name: "client name".replace(/,/g, ""),
        billingInformation: "billing Information".replace(/,/g, ""),
        qty_samples: "qty samples".replace(/,/g, ""),
        date_reception: "date reception".replace(/,/g, ""),
        lastResultDate: "last result date".replace(/,/g, ""),
        result_date: "result date".replace(/,/g, ""),
        zone: "zone".replace(/,/g, ""),
        client_type: "client type".replace(/,/g, ""),
        sampler_name: "sampler name".replace(/,/g, ""),
      };

      let date = new Date();
      var fileTitle = `data-solena-export-${date}`; // or 'my-unique-title'

      this.exportCSVFile(headers, allData, fileTitle);
      this.isExporting = false;
    },
    showDateResultHistoryModal(item) {
      this.SET_FOLIO_SELECTED(item);
      this.showTimeLineResultsDate = true;
    },
    getKitType(value) {
      let types = {
        CLASSIC: "Tradiciónal",
        HYBRID: "Híbrido",
        QPCR: "QPCR",
        OTHER: "Otro",
        SEQUENCING: "Secuenciación",
      };
      let type = types[value];
      if (type) {
        return type;
      } else {
        return "N.E.";
      }
    },
    showChangePackageDialog(item) {
      this.SET_SELECTED_RECEPTION(item);
      this.showSetPackageInAnalysisModal = true;
    },
    async hideChangePackageDialog() {
      this.SET_SELECTED_RECEPTION(null);
      this.showSetPackageInAnalysisModal = false;
      await this.fetchData();
    },
  },
  watch: {
    async search() {
      this.page = 1;
      await this.fetchData();
    },
    async page() {
      if (this.page != parseInt(this.$route.params.page)) {
        this.$router.replace({
          params: {
            page: this.page,
          },
        });
      }
      await this.fetchData();
    },
    async refreshReceptionTable(value) {
      if (value) {
        this.SET_REFRESH_TABLE(false);
        await this.fetchData();
      }
    },
    selectedParend(value) {
      this.SET_FOLIOS_SELECTED(value);
    },
    cleanParent(value) {
      if (value) {
        this.selectedParend = [];
        this.CLEAN_PARENT(false);
      }
    },
  },
};
</script>

<style scoped>
.loading-icon:before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #04c105;
  border-top-color: rgba(170, 213, 170, 0.6);
  color: green;
  border-radius: 50%;
  animation: spin 1s infinite linear;
  margin-right: 5px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.package__type {
  transition: transform 0.5 ease;
}

.package__type:hover {
  cursor: pointer;
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
</style>
